export const MAXIMUM_NUMBER_OF_LABELS = 55;
export const MAXIMUM_LABEL_LENGTH = 255;
